<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <warehouse-form v-if="warehouse"
          @submit="submit"
          :init-warehouse="warehouse"
          :val-errors="valErrors"
          submit-text="Speichern"
        />
      </card>
    </div>
  </div>
</template>

<script>
import WarehouseForm from './warehouse-form'

export default {
  components: { WarehouseForm },
  data () {
    return {
      warehouse: null,
      valErrors: []
    }
  },
  methods: {
    async submit (warehouse) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.put(`/warehouses/${warehouse.id}`, warehouse).then(({ data }) => {
        this.$notify({
          message: 'Lager erfolgreich bearbeitet.',
          type: 'success'
        })
        this.$router.push('/warehouses')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/warehouses/${this.$route.params.id}`).then(({ data }) => {
      this.warehouse = data
    })
  }
}
</script>

<style>
</style>
